import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_ENDPOINT_CACHE_PETITION_STATS = defineFcm('promotions_endpoint_cache_petition_stats')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'promotion-service',
		context: 'promotion-service',
		description:
			'In the event that the promotion_service stats endpoint needs to generate petition promotion stats (loss of Redis data), this flag can be set to store the result in Redis. This data should be populated in Redis by the Promotion Stats Worker.',
		import: false,
	});
